export default "__VITE_ASSET__de507ee8__"